import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab13',
  templateUrl: './awsop-lab13.component.html',
  styleUrls: ['./awsop-lab13.component.css']
})
export class AwsopLab13Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab13/awsop-lab13.component.ts